import React, { useEffect, useState } from "react";
import "../styles/InfoGrid.css";
import { FaLinkedin, FaGithub, FaEnvelope, FaPhone } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const InfoGrid = () => {
  const [experience, setExperience] = useState(0);
  const [cupsOfCoffee, setCupsOfCoffee] = useState(0);
  const [linesOfCode, setLinesOfCode] = useState(0);
  const navigate = useNavigate();

  // Animation Effect for Numbers
  useEffect(() => {
    const animateValue = (setter, finalValue, duration) => {
      let start = 0;
      const increment = Math.ceil(finalValue / (duration / 50));

      const timer = setInterval(() => {
        start += increment;
        if (start >= finalValue) {
          start = finalValue;
          clearInterval(timer);
        }
        setter(start);
      }, 50);
    };

    animateValue(setExperience, 4, 2000);
    animateValue(setCupsOfCoffee, 2000, 2000);
    animateValue(setLinesOfCode, 300000, 2000);
  }, []);

  return (
    <div className="info-grid">
      {/* Row 1 */}
      <div className="info-row">
        <div className="info-box large-text">
          <h3>Experience</h3>
          <p>{experience} + years</p>
        </div>
        <div className="info-box large-text">
          <h3>Cups of Coffee</h3>
          <p>{cupsOfCoffee} +</p>
        </div>
        <div className="see-also-box">
          <h3>Strength</h3>
          <p>Systems Design & Problem Solving</p>
        </div>
      </div>

      {/* Row 2 */}
      <div className="info-row">
        <div className="info-box large-text">
          <h3>Lines of Code</h3>
          <p>{linesOfCode.toLocaleString()} +</p>
        </div>
        <div className="info-box">
          <h3>Education</h3>
          <p>Double Master's in Computer Science</p>
        </div>
        <div className="see-also-box">
          <h3>Skills</h3>
          <p> Java, Python, React, Django, Spring, SQL</p>
        </div>
      </div>

      {/* Row 3 */}
      <div className="info-row">
        <div className="info-box">
          <h3>Connect Me</h3>
          <div className="social-links">
            <a href="https://www.linkedin.com/in/srijansa/" target="https://www.linkedin.com/in/srijansa/" rel="noopener noreferrer">
              <FaLinkedin className="social-icon linkedin" />
            </a>
            <a href="https://github.com/srijansa" target="https://github.com/srijansa" rel="noopener noreferrer">
              <FaGithub className="social-icon github" />
            </a>
            <a href="mailto:srijansa@buffalo.edu">
              <FaEnvelope className="social-icon email" />
            </a>
            <a href="tel:+17166178379">
              <FaPhone className="social-icon phone" />
            </a>
          </div>
        </div>
        <div className="info-box hire-me" onClick={() => navigate("/about")}>
          <h1 className="animated-hire-me">HIRE ME</h1>
        </div>
      </div>
    </div>
  );
};

export default InfoGrid;
